import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../../shared/tabs.component';

import DetailsTab, { TaxEntryPropTypes } from './detailsTab.component';
import SubledgerJournalsTab from './subledgerJournalsTab.component';
import SubledgerJournalsPropTypes from './subledgerJournals.propTypes';
import GLJournalsTab from './glJournalsTab.component';
import GLJournalsPropTypes from './glJournals.propTypes';
import AuditTab from './auditTab.component';
import AttachmentsTab from './attachmentsTab.component';
import { attachmentPropType } from './propTypes';

export const TabTypes = {
  DETAILS: 'DETAILS',
  SUBLEDGER_JOURNALS: 'SUBLEDGER_JOURNALS',
  GL_JOURNALS: 'GL_JOURNALS',
  AUDIT: 'AUDIT',
  ATTACHMENTS: 'ATTACHMENTS',
};

class TaxEntry extends PureComponent {
  static propTypes = {
    taxEntry: TaxEntryPropTypes,
    taxEntryData: PropTypes.shape({
      subledgerJournals: SubledgerJournalsPropTypes,
      GLJournals: GLJournalsPropTypes,
      attachments: PropTypes.arrayOf(attachmentPropType),
    }).isRequired,
  };

  state = {
    activeTab: TabTypes.DETAILS,
  };

  changeTab = (event, tabType) => {
    this.setState({
      activeTab: tabType,
    });
  };

  render() {
    const { activeTab } = this.state;
    const { taxEntry, taxEntryData } = this.props;

    return (
      <div className="tax-entry page-content-container">
        <Tabs
          defaultValue={TabTypes.DETAILS}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.DETAILS} label="Details">
            <DetailsTab taxEntry={taxEntry} />
          </Tab>

          <Tab value={TabTypes.SUBLEDGER_JOURNALS} label="Subledger Journals">
            <SubledgerJournalsTab subledgerJournals={taxEntryData.subledgerJournals} />
          </Tab>

          <Tab value={TabTypes.GL_JOURNALS} label="GL Journals">
            <GLJournalsTab glJournals={taxEntryData.GLJournals} />
          </Tab>

          <Tab value={TabTypes.AUDIT} label="Audit">
            <AuditTab taxEntry={taxEntry} />
          </Tab>

          <Tab value={TabTypes.ATTACHMENTS} label="Attachments">
            <AttachmentsTab attachments={taxEntryData.attachments} />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default TaxEntry;
